const removeDuplicateFilters = (filters) => {
  const seen = new Set();
  return filters.filter((filter) => {
    const key = `${filter.field}:${filter.value}:${filter.operator}`;
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
};

export default removeDuplicateFilters;
